import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../../util/localstorage.service'; 
import { User } from '../../models/user.model';
import { Constants } from '../../util/constants';
import { Router } from '@angular/router';
import { ClinicDataService } from '../clinic/clinic-data.service';
import { BsModalService,BsModalRef}   from 'ngx-bootstrap/modal';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators } from "@angular/forms";
import { AlertService } from '../../util/alert/alert.service';
import { AnimateShowChangeCellRenderer, GridOptions, RowNode } from 'ag-grid-community';
// import { FileUploadService } from './file-upload.service';
import {FileUploadService} from './file-upload.service'
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-clinic-details',
  templateUrl: './import-data.component.html',
  styleUrls: ['./import-data.component.scss']
})
export class ImportDataComponent implements OnInit {

  public paddingtop: number = 160;
  public iSForm: FormGroup;
  public clinicname
  public isAdminUser
  public clinicsforfilter: Array<any> =[]
  public selectedClinic: Array<any> =[]
  public gridOptions : GridOptions
  private gridApi: any;
  private gridColumnApi: any;
  public defaultColDef
  public rowData: any;
  public columnDefs: any;
  public clinics: Array<any> =[]
  private clinicid: string;
  public rowDataLocation: any;
  public name
  public updateMode 
  public file:any
  public fileToUpload: FormData;
  public clinic
  public gender: boolean
  public email: boolean
  public showgrid: boolean = false
  loggedUser: any;
  

  constructor(private router: Router, private formBuilder: FormBuilder,private alertService: AlertService,
    private clinicService: ClinicDataService,  private bsModalService :BsModalService, private fileUploadService:FileUploadService, private http: HttpClient){
   
      var self = this;
      this.gridOptions = {
        rowData: this.rowData,
        columnDefs: this.columnDefs,
        enableColResize: true,
        enableSorting: true,
        rowSelection: "single",
        rowHeight: 35,
        rowDeselection: true,
        animateRows: true,
        rowBuffer: 20,
        context: {
          componentParent: this
        },
        paginationPageSize: 10
      };
  
      this.defaultColDef = {
        //autoHeight: true,
        resizable: true,
        filter: true,
      };

    }

  ngOnInit():void {
    this.loggedUser   = JSON.parse(localStorage.getItem(LocalStorage.LOGGED_USER)) as User;
    if(this.loggedUser.UserRoleID == Constants.UserRoleID.AdminUser){
      this.isAdminUser = true
    } else{
      this.isAdminUser = false
    } 
    this.clinicService.getClinics(this.loggedUser).subscribe(data => this.getClinicData(data))
    if(this.isAdminUser){
      this.clinicid = this.loggedUser.ClinicID
    }

    this.iSForm = this.formBuilder.group({
      clinic: new FormControl(null),
      clinicname: new FormControl(null),
    } );

    this.columnDefs = [
      {
        headerName: 'Error Message', 
        field: 'errormessage',
        width: 60,
        cellStyle: {color: 'red'}
      },
      {
        headerName: 'First Name', 
        field: 'firstname',
        width: 40,
      },
      { 
        headerName: 'Last Name', 
        field: 'lastname',
        width: 40,
      },
      { 
        headerName: 'Date of Birth', 
        field: 'dob',
        hide: this.gender,
        width: 40,
      },
      { 
        headerName: 'Gender', 
        field: 'ismale',
        width: 45
      },
      { 
        headerName: 'Email', 
        field: 'email',
        width: 45
      }
    ];
  }

  gridSizeChanged(params: any) {
		params.api.sizeColumnsToFit();
  }

  onGridReady(params: any) { 
    this.rowData = []
		this.gridApi  = params.api;
    this.gridColumnApi = params.columnApi; 
    this.gridApi.sizeColumnsToFit();
  }
  
  public getClinicData(data: any) {
    this.clinics = data  
    if(this.isAdminUser){
    data.forEach((element: any) => {
      if(this.clinicid != null && this.clinicid != undefined && this.clinicid == element.ClinicID){
        this.clinicname = element.ClinicName       
      }
    });
    } 
  }

  uploadPatientFileToActivity() {
    this.alertService.clear();
    if(this.clinicid != null && this.clinicid != "" && this.clinicid != undefined){ 
      if(this.fileToUpload != null && this.fileToUpload != undefined){
        this.alertService.info('Please wait.. file is uploading')
        this.fileUploadService.postPatientsFile(this.fileToUpload,this.loggedUser).subscribe(data => {
          if(data != null && data != []){ 
            this.alertService.clear();
            (<HTMLInputElement>document.getElementById('patientfile')).value = "";
            if(data.length != undefined && data.length > 0){
              this.alertService.info('Completed data import with errors. Please see the error list')
              this.showgrid = true
            } else{
              this.alertService.success('Successfully uploaded')
              this.showgrid = false
            }
            this.fileToUpload = null
            this.clinic = null
            this.selectedClinic = []
            this.clinicid = ""
            this.setData(data,"patient")
          }
          }, error => {
            if(error.status == "400"){
              this.alertService.clear();
              this.alertService.error('Invalid file')
              this.showgrid = false
            } else{
              this.alertService.clear();
              this.alertService.error('Error occured while saving data')
              this.showgrid = false
            }
          });
        } else{
          this.alertService.clear();
          this.alertService.error('No file is selected')
        }
      } else{
        (<HTMLInputElement>document.getElementById('patientfile')).value = "";
        this.alertService.error('Please select a clinic')
      }
    }

    uploadUserFileToActivity() {
      this.alertService.clear();
      if(this.clinicid != null && this.clinicid != "" && this.clinicid != undefined){ 
        if(this.fileToUpload != null && this.fileToUpload != undefined){
          this.alertService.info('Please wait.. file is uploading')
          this.fileUploadService.postUsersFile(this.fileToUpload,this.loggedUser).subscribe(data => {
            if(data != null && data != []){   
              debugger
              this.alertService.clear();
              (<HTMLInputElement>document.getElementById('userfile')).value = "";
              if(data.length != undefined && data.length > 0){
                this.alertService.info('Completed data import with errors. Please see the error list')
                this.showgrid = true
              } else{
                this.alertService.success('Successfully uploaded')
                this.showgrid = false
              }
              this.fileToUpload = null
              this.clinic = null
              this.clinicid = ""
              this.selectedClinic = []
              this.setData(data,"user")
              
            }
            }, error => {
              if(error.status == "400"){
                this.alertService.clear();
                this.alertService.error('Invalid file')
                this.showgrid = false
              } else{
                this.alertService.clear();
                this.alertService.error('Error occured while saving data')
                this.showgrid = false
              }
            });
          } else{
            this.alertService.clear();
            this.alertService.error('No file is selected')
          }
        } else{
          (<HTMLInputElement>document.getElementById('userfile')).value = "";
          this.alertService.error('Please select a clinic')
        }
      }

    handleFileInput(event: any) {
      this.showgrid = false
      this.alertService.clear();
      if(this.clinicid != null && this.clinicid != "" && this.clinicid != undefined){ 
        this.fileToUpload = null
        let data: any
        data = event.target.files[0];
        if(data != null && data != undefined){
          const formData: FormData = new FormData();
          formData.append("fileUpload", data);
          formData.append("clinicid", this.clinicid);
          formData.append("userid", this.loggedUser.UserID);
          this.fileToUpload = formData
        }
      } else{
        (<HTMLInputElement>document.getElementById('userfile')).value = "";
        (<HTMLInputElement>document.getElementById('patientfile')).value = "";
        this.alertService.error('Please select a clinic')
      }
    }

    public clinicChange(event: any): void {
      this.alertService.clear();
      if(event.value != undefined){
        this.clinicid = event.value.ClinicID
        this.showgrid = false
      }     
    }


    public setData(data: any, type: string) {
      this.rowData = []
      let Gender: String
      let FirstName: String
      let LastName: String
      let Email: String
      let DateOfBirth: String
      let ErrorMessage: String
      data.forEach((element: any) => {
        ErrorMessage = element.ErrorMessage.replace(/^,/, '')
        FirstName = element.FirstName
        LastName = element.LastName
        var datePipe = new DatePipe('en-US');
        if(datePipe.transform(element.DateOfBirth, 'MM/dd/yyyy') != "01/01/0001"){
          DateOfBirth = datePipe.transform(element.DateOfBirth, 'MM/dd/yyyy');
        } else{
          DateOfBirth = "";
        }
        if(type == "patient"){
          if(element.IsMale != null && element.IsMale != undefined && element.IsMale != ""){
            if(element.IsMale == true){
              Gender = "Male"
            } else{
              Gender = "Female"
            }
          }
          this.gridOptions.columnApi.setColumnVisible('ismale', true)
          this.gridOptions.columnApi.setColumnVisible('email', false)
                    
        } else{
            this.gridOptions.columnApi.setColumnVisible('ismale', false)
        }


        if(type == "user"){
          Email = element.Email
          this.gridOptions.columnApi.setColumnVisible('email', true)
          this.gridOptions.columnApi.setColumnVisible('ismale', false)
        }else{
          this.gridOptions.columnApi.setColumnVisible('email', false)
        }   
        this.rowData.push({errormessage: ErrorMessage, firstname: FirstName, lastname: LastName,
          dob: DateOfBirth, ismale: Gender, email: Email})
    
      });
      if(this.gridOptions.api != undefined && this.gridOptions.api != null){
        this.gridOptions.api.setRowData(this.rowData);
      }
      this.gridOptions.api.sizeColumnsToFit();
      return this.rowData;
    }
}
